export default __webpack_public_path__ + "static/media/upload-module-image.cf3182a4.svg";